import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class BlockTextCards {
    constructor() {
        this.blocks = document.querySelectorAll(".block-text-cards");

        if (this.blocks && this.blocks.length > 0) {
            this.updateCardsMaxHeight();
            GlobalVariables.resizeCallbacks.push(this);
        }
    }

    updateCardsMaxHeight() {
        this.blocks.forEach(block => {
            const row = block.querySelector('.cards-reveal');
            if (!row) return;

            const cards = row.querySelectorAll('.item-card');
            if (!cards.length) return;

            row.style.setProperty('--max-height', `auto`);

            // récupérer la hauteur max
            let maxHeight = 0;
            cards.forEach(card => {
                const h = card.offsetHeight;
                if (h > maxHeight) {
                    maxHeight = h;
                }
            });

            const mm = gsap.matchMedia();
            mm.add("(min-width: 768px)", () => {
                row.style.setProperty('--max-height', `${maxHeight}px`);

                return () => {
                    row.style.setProperty('--max-height', `auto`);
                };
            });
        });

    }

    resize() {
        this.updateCardsMaxHeight();
    }
}